var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 35.073,
    viewBox: "0 0 26.5 35.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_81",
    "data-name": "group 81",
    transform: "translate(-466.106 -2372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_35",
    "data-name": "path 35",
    d: "M479.356,2407.073c10.132,0,13.25-7.794,13.25-12.47,0-7.015-5.456-15.588-5.456-15.588a21.1,21.1,0,0,0-2.338,6.235c-.779-7.015-5.456-13.25-5.456-13.25s-4.676,6.235-5.456,13.25a21.1,21.1,0,0,0-2.338-6.235s-5.456,8.574-5.456,15.588C466.106,2399.28,469.224,2407.073,479.356,2407.073Z",
    transform: "translate(0)",
    fill: "#e60012"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_80",
    "data-name": "group 80",
    transform: "translate(471.531 2386.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_36",
    "data-name": "path 36",
    d: "M482.251,2403.583l-.131,3.067-2.058.281v-3.348h-5.818l-.374-1.591,6.192-.318v-2.207H473.44l-.374-1.59,9.278-.43a18.916,18.916,0,0,0,.786-2.142q.281-.964.374-1.319h-9.072l-.374-1.59,5.986-.318v-1.964l2.432.281-.224,1.571,6.248-.318v2.338h-4.433l2.245.711q-.543.767-1.02,1.375t-1.113,1.3l5.35-.243v2.338h-7.09l-.094,2.095,6.341-.317v2.338Zm-2.376-7.764a1.692,1.692,0,1,1-.5-1.188A1.62,1.62,0,0,1,479.875,2395.819Z",
    transform: "translate(-473.066 -2390.114)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard);
export default __webpack_public_path__ + "static/media/hard.4b4fa03d49228b6d860c762fd86c8da8.svg";
export { ForwardRef as ReactComponent };